import { withAssetPrefix } from "gatsby";
import { trackCustomEvent } from "../utilities/analytics";
import React, { SyntheticEvent } from "react";
import { useInView } from "react-intersection-observer";

type Props = {
  className?: string;
  controls?: boolean;
  description?: string;
  hideDescription?: boolean;
  onClick?: React.MouseEventHandler<HTMLVideoElement>;
  path: string;
  screenshots: { path: string }[];
};

export default function Video({
  className,
  controls = true,
  description,
  hideDescription,
  onClick,
  path,
  screenshots,
}: Props) {
  const [{ path: poster }] = screenshots;
  const [ref, inView] = useInView({ triggerOnce: true, rootMargin: "200px" });

  const eventHandler = (e: SyntheticEvent<HTMLVideoElement>) => {
    trackCustomEvent({
      action: `Video ${e.type}`,
      category: "Engagement",
      label: description,
    });
  };

  return (
    <div className="container px-10 pb-20 mx-auto">
      <video
        className={className}
        controls={controls}
        data-testid="video"
        onClick={onClick}
        onEnded={eventHandler}
        onError={eventHandler}
        onPause={eventHandler}
        onPlay={eventHandler}
        playsInline
        poster={
          inView
            ? poster.startsWith("/")
              ? withAssetPrefix(poster)
              : poster
            : undefined
        }
        preload="none"
        ref={ref}
      >
        <source src={withAssetPrefix(path)} type="video/mp4" />
      </video>
      {hideDescription || (
        <h2 className="pt-5 font-bold text-center text-md">{description}</h2>
      )}
    </div>
  );
}
